import Splide from '@splidejs/splide';
import '@splidejs/splide/css';

// Store carousel instances to prevent duplicates
const carouselInstances = new Map();

export default class ProductImageCarousel {
  constructor(selector = '.product-image-carousel') {
    this.selector = selector;
    this.carousel = null;
    this.init();
  }

  init() {
    const carouselElement = document.querySelector(this.selector);
    if (!carouselElement) {
      return;
    }

    // Check if this element already has a carousel instance
    if (carouselInstances.has(carouselElement)) {
      const existingInstance = carouselInstances.get(carouselElement);
      if (existingInstance && existingInstance.carousel) {
        existingInstance.carousel.destroy();
      }
      carouselInstances.delete(carouselElement);
    }

    // Destroy existing instance if it exists
    if (this.carousel) {
      this.carousel.destroy();
      this.carousel = null;
    }

    // Initialize Splide
    this.carousel = new Splide(carouselElement, {
      type: 'slide',
      perPage: 1,
      perMove: 1,
      gap: '20px',
      pagination: false,
      arrows: true,
      rewind: true,
      autoplay: false,
      breakpoints: {
        768: {
          gap: '20px',
        },
      },
    });

    this.carousel.mount();
    
    // Store instance for cleanup
    carouselInstances.set(carouselElement, this);
  }

  destroy() {
    if (this.carousel) {
      this.carousel.destroy();
      this.carousel = null;
    }
    
    // Remove from instances map
    const carouselElement = document.querySelector(this.selector);
    if (carouselElement && carouselInstances.has(carouselElement)) {
      carouselInstances.delete(carouselElement);
    }
  }
}

